const htmlEntities = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&apos;',
};

const escapePattern = /[&<>"']/g;
const escapeNoEncodePattern = /[<>"']|&(?!(#\d{1,7}|#[Xx][a-fA-F0-9]{1,6}|\w+);)/g;

const getEscapeReplacement = (ch: string) =>
    htmlEntities[ch as keyof typeof htmlEntities];

export function escapeHtml(html: string, encode?: boolean): string {
    const pattern = encode ? escapePattern : escapeNoEncodePattern;

    return html.replace(pattern, getEscapeReplacement);
}
